export default __webpack_public_path__ + "static/media/24-1.fc3a0d3d.mp3";